<div>
    
    <div class="wrapper" id="print-section">
        <div class="header">
            <span class="left-header  pl-2">
                दि.{{ today | date:'dd/MM/yyyy hh:mm:ss' }} साप्तहिक विवेक
            </span>
            <span style="width: 686px;">
                <button  matTooltip="Save Barcodes" *ngIf="saveStatus=='ADD'" mat-raised-button tyle="margin-right: 2%; margin-left: 2%; z-index: 10;font-size: 12px; font-weight: 600;" 
                color="danger" (click)="saveSubscriptionBarcodesDataEntry()">
                Save
            </button>
            <button [useExistingCss]="true" class="noPrint"
                style="margin-right: 2%; margin-left: 2%; z-index: 10;font-size: 12px; font-weight: 600;" mat-raised-button
                color="primary" printTitle="Label" printSectionId="print-section" ngxPrint>
                Print
            </button>
            <button matTooltip="Export Excel" class="noPrint" *ngIf="saveStatus!='ADD' && delivery_mode_name == 'मॅगझीन पोस्ट'" mat-raised-button style="margin-right: 2%; margin-left: 2%; z-index: 10;font-size: 12px; font-weight: 600;" color="warning" (click)="exportExcel()">
              Magzine Post Excel
            </button>
            <button matTooltip="Export Excel" class="noPrint" *ngIf="saveStatus!='ADD' && delivery_mode_name == 'टपाल'" mat-raised-button style="margin-right: 2%; margin-left: 2%; z-index: 10;font-size: 12px; font-weight: 600;" color="warning" (click)="exportExcelForPost()">
                Post Excel
            </button>

            <button matTooltip="Export Excel" class="noPrint" *ngIf="saveStatus!='ADD' && !delivery_mode_name" mat-raised-button style="margin-right: 2%; margin-left: 2%; z-index: 10;font-size: 12px; font-weight: 600;" color="warning" (click)="exportExcelAll()">
              Excel
            </button>
   
            <button mat-dialog-close class="btn noPrint" style=" z-index: 10">Close</button>
            </span>
            
        </div>
        
    
        <div class="content">
            <ng-container *ngFor="let page of paginatedData(); let i = index">
                <div class="page">
                    <div *ngFor="let row of page;let j = index" class="page-inner">

                        <div class="print-row" style="margin-left: 10px; margin-right: 6px;">
                            <div class="print-item" *ngFor="let item of row">
                                <ng-container *ngIf="item">
                                  <!-- <span *ngIf="item.BARCODE_NUMBER && item.BARCODE_NUMBER.toString().trim().substring(0,2) === 'MP'" style="font-size: 14px; font-weight: bold;">ID - 3000056976</span><br /> -->
                                
                                  <!-- <span *ngIf="isIds?.toString().trim().toUpperCase() === 'YES'" style="font-size:14px;font-weight:bold;">
                                    {{ item.magzineIdName }}
                                </span>
                                <br /> -->

                                <span *ngIf="!isIds || isIds?.toString().trim().toUpperCase() !== 'NO'" style="font-size:14px;font-weight:bold;">
                                    {{ item.magzineIdName }}
                                </span>
                                <br />
                                  
                                <!-- <span *ngIf="
                                    (saveStatus == 'ADD' || saveStatus == 'UPDATE') &&
                                    (
                                      item.delivery_mode?.toString().trim() == 'मॅगझीन पोस्ट' ||
                                      item.delivery_mode_name?.toString().trim() == 'मॅगझीन पोस्ट' ||
                                      delivery_mode_name?.toString().trim() == 'मॅगझीन पोस्ट' ||
                                      !delivery_mode_name
                                    ) &&
                                    (
                                      item.BARCODE_NUMBER?.toString().trim()?.startsWith('MP') ||
                                      item.postalCode?.toString().trim()?.startsWith('MP')
                                    )
                                  "
                                  style="font-size: 14px; font-weight: bold;">
                                
                                  ID - 3000056976
                                
                                </span><br /> -->
                                  
<span style="font-size: 14px; font-weight: bold;">{{ item["title"] }} {{ item["name"] }}</span><br />
                                  <!-- <span style="font-size: 13px;">{{ item["address"] }}</span><br /> -->
                            <span class="address" style="font-weight: bold;"  *ngIf="item['pincode'] !== 0" [class.long-address]="item['address']?.length > 40">
                                {{ item["address"] }} {{ item["taluka"] }}, {{ item["district"] }} - {{ item["pincode"] }} {{ item["state"] }}
                            </span><br />

                                  <!-- <span style="font-size: 13px;">{{ item["taluka"] }}, {{ item["district"] }}</span><br />
                                  <span style="font-size: 13px;" *ngIf="item['pincode'] !== 0">  {{ item["pincode"] }} {{ item["state"] }}</span><br /> -->
                                  <!-- <span style="font-size: 13px;">
                                    {{ item["district"] }},
                                    <span *ngIf="item['pincode'] !== 0"> - {{ item["pincode"] }} {{ item["state"] }}</span>
                                  </span><br /> -->
                                  <span style="font-size: 14px; font-weight: bold;">मो. नं. - {{ item["mobileNumber"] }}</span><br />
                                  <ngx-barcode6 
                                    [bc-format]="'CODE128'" 
                                    [bc-value]="item['postalCode']"
                                    [bc-display-value]="true" 
                                    [bc-width]="1.3" 
                                    [bc-height]="25">
                                  </ngx-barcode6>
                                </ng-container>
                              </div>
                              
                        </div>
                        <!-- <div class="footer">
                            <span class="right-header noScreen">
                              पृष्ठ क्र. {{ j + 1 }}
                            </span>
                          </div> -->
                         
                    </div>
                   
                    <div class="page-break" *ngIf="pageIndex < paginatedData().length - 1"></div>
                    <div class="print-row-1">
                    <span class="right-header-1">
                        पृष्ठ क्र. {{ i + 1 }}
                      </span>
                    </div>
                </div>
              
              
            </ng-container>
        </div>
    
        <!-- <div class="footer">Page Footer</div> -->
    </div>
    
    
</div>

<!-- <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.2.1/jquery.min.js">
        var bottom = 0;
        $(document).ready(function () {
            $('.col-3:nth-child(100n)').each(function () {
                bottom -= 100;
                botString = bottom.toString();
                var $counter = $('h3.first').clone().removeClass('first');
                $counter.css('bottom', botString + 'vh');
                ($counter).insertBefore('.insert');
            });
        });
    </script> -->
<!-- </body> -->